import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';

const PriceAmounts = ({ price, beforeDecimal, afterDecimal }) => {
    const lang = LocaleService.getSimpleLocale();
    const showBefore = lang !== 'fr';

    const hasNegativeSymbol = (value) => isString(value) && value.indexOf('-') !== -1;
    const removeDollarSign = (value) => (isString(value) ? value.replace('$', '') : value);
    const removeNegativeSign = (value) => (isString(value) ? value.replace('-', '') : value);
    const getFinalPrice = (value) => removeNegativeSign(removeDollarSign(value));

    return (
        <>
            {hasNegativeSymbol(beforeDecimal || price) ? '-' : ''}
            {showBefore && !afterDecimal && <span className="currency-symbol">$</span>}
            {beforeDecimal && getFinalPrice(beforeDecimal)}
            {price && getFinalPrice(price)}
            {afterDecimal && getFinalPrice(afterDecimal)}
            {!showBefore && !beforeDecimal && <span className="currency-symbol fr">$</span>}
        </>
    );
};

PriceAmounts.propTypes = {
    price: PropTypes.string,
    beforeDecimal: PropTypes.string,
    afterDecimal: PropTypes.string,
};

PriceAmounts.defaultProps = {
    price: '',
    beforeDecimal: '',
    afterDecimal: '',
};

PriceAmounts.displayName = 'PriceAmounts';

export default PriceAmounts;
